import { Message, MessageUser } from "../../../types/MessageListType";
import { useAppSelector } from "../../../utils/hooks";
import { useTranslateText } from "../../../hooks/useTranslateText";
import { formatSystemMessageText } from "../../../utils/formatSystemMessageText";

export default function SystemMessage({
  messageData,
}: {
  messageData: Message;
}) {
  const ContactList = useAppSelector((state) => state.ContactList);
  const userData = useAppSelector((state) => state.userData);
  const translate = useTranslateText();

  const text = formatSystemMessageText(messageData, {
    currentUserId: userData.user_id,
    translate,
    resolveName: (u) => {
      const contact = ContactList?.data?.find(
        (e) => e?.user_id == (u as MessageUser)?.user_id,
      );
      return contact?.name ?? (u as MessageUser)?.full_name ?? "";
    },
  });

  return (
    <div
      key={messageData.message_id}
      id={String(messageData.message_id)}
      data-message-id={messageData.message_id}
      className="mx-auto my-3 w-fit rounded-full bg-primary px-5 py-1 text-center text-sm font-medium text-darkText shadow-sm"
    >
      {text}
    </div>
  );
}
